<!-- Created by henian.xu on 2019/10/14. -->

<template>
    <div class="login-page-custom">
        <div class="inner">
            <div class='logo'>
                <img
                    src='~@/assets/logo.png'
                    alt='logo'
                >
            </div>
            <div class="header">
                <div>福州市闽都职业培训学校</div>
                <div>准考证自助打印端</div>
            </div>
            <div class="body">
                <div class="form-input">
                    <!--                    <div class="label">-->
                    <!--                        账号:-->
                    <!--                    </div>-->
                    <div class="input">
                        <input
                            type="text"
                            v-model="formModel.account"
                            @keydown.enter="()=>{onSubmit()}"
                            placeholder='请输入账号'
                        >
                        <transition name="form-input-show">
                            <div
                                v-show="!formModel.account"
                                class="error"
                            >
                                请输入账号
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="form-input">
                    <!--                    <div class="label">-->
                    <!--                        密码:-->
                    <!--                    </div>-->
                    <div class="input">
                        <input
                            type="password"
                            v-model="formModel.password"
                            @keydown.enter="()=>{onSubmit()}"
                            placeholder='请输入密码'
                        >
                        <transition name="form-input-show">
                            <div
                                v-show="!formModel.password"
                                class="error"
                            >
                                请输入密码
                            </div>
                        </transition>
                    </div>
                </div>
                <div class='ctrl'>
                    <div
                        class="btn submit"
                        @click="()=>{onSubmit()}"
                    >
                        登录
                    </div>
                    <div
                        class="btn reset"
                        @click="()=>{onReset()}"
                    >
                        清空
                    </div>
                </div>

                <div class='desc'>忘记密码，请联系管理员</div>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('User');
// import { GlobalVar } from '@vmf/shared';

export default {
    name: 'LoginPage',
    data() {
        return {
            siteDetail: this.$utils.GlobalVar.site || { name: '管理系统' },
            formModel: {
                account: this.$utils.GlobalVar.isDev ? 'admin' : '',
                password: this.$utils.GlobalVar.isDev ? 'admin' : '',
            },
        };
    },
    beforeRouteEnter(to, from, next) {
        const { backUrl } = to.query;
        if (backUrl) {
            next();
            return;
        }
        next({
            ...to,
            replace: true,
            query: {
                ...to.query,
                backUrl: from.fullPath,
            },
        });
    },
    computed: {
        backUrl() {
            let backUrl = decodeURIComponent(this.$route.query.backUrl || '/');
            if (/^\/login/.test(backUrl)) {
                backUrl = '/';
            }
            return backUrl;
        },
    },
    methods: {
        ...mapActions(['login']),
        onReset() {
            this.formModel = {
                account: '',
                password: '',
            };
        },
        async onSubmit() {
            if (Object.values(this.formModel).some(item => !item)) return;

            await this.login(this.formModel);

            this.$router.replace(this.backUrl);
        },
    },
    created() {
        this.$nextTick(() => {
            document.documentElement.classList.add('html-full');
        });
    },
    destroyed() {
        document.documentElement.classList.remove('html-full');
    },
};
</script>

<style lang="scss">
.login-page-custom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f2f2f2 center no-repeat;
    background-size: cover;
    min-height: 100%;
    min-width: 1200px;

    > .inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        > .logo {
            width: 200px;
            height: 200px;
            border-radius: 100vw;
            overflow: hidden;
            margin-bottom: 10px;
            > img {
                width: 100%;
                height: 100%;
            }
        }
        > .header {
            letter-spacing: 5px;
            font-size: 20px;
            margin-bottom: 10px;
            text-align: center;
        }
        > .body {
            box-sizing: border-box;
            padding: 20px 0;
            border-radius: 10px;
            width: 400px;

            > .form-input {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 30px;
                font-size: 15px;
                > .label {
                    flex: 0 0 auto;
                    text-align: right;
                    margin-right: 10px;
                }
                > .input {
                    position: relative;
                    flex: 1 1 1%;
                    > input {
                        position: relative;
                        z-index: 100;
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        font-size: 15px;
                        border: 1px solid $gray3;
                        border-radius: 5px;
                        outline: none;
                        padding: 0 10px;
                        box-sizing: border-box;
                    }
                    > .error {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 100%;
                        color: #f00;
                    }
                }
            }

            > .ctrl {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 0 $padding-big;
                > .btn {
                    width: 8em;
                    line-height: 40px;
                    height: 40px;
                    text-align: center;
                    border-radius: 5px;
                    cursor: pointer;
                    user-select: none;
                    border: 1px solid $gray3;
                    background-color: #fff;
                }
                > .submit {
                    background-color: #409eff;
                    border-color: #409eff;
                    color: #fff;
                }
            }
            > .desc {
                text-align: center;
                margin-top: $margin;
                color: $gray6;
            }
        }
    }
}

@keyframes form-input-in {
    0% {
        opacity: 0;
        transform: translate(0, -100%);
    }
    100% {
        opacity: 1;
        transform: translate(0, 0);
    }
}

@keyframes form-input-out {
    0% {
        opacity: 1;
        transform: translate(0, 0);
    }
    100% {
        opacity: 0;
        transform: translate(0, -100%);
    }
}

.form-input-show-enter-active {
    animation: form-input-in 0.5s;
}

.form-input-show-leave-active {
    animation: form-input-out 0.5s;
}
</style>
